import { render } from "./city-zone.vue?vue&type=template&id=1977798d"
import script from "./city-zone.vue?vue&type=script&lang=js"
export * from "./city-zone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__